module.exports = __webpack_public_path__ + "img/baml.b52b7dff.png";